import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class WhitepapersService {

  //list of published white papers
  private papers: any[] = [
    { title: 'Fear v/s Cost: Overcoming Compliance Dual Challenges', url: 'https://discover.c2labs.com/fear-vs.-cost-overcoming-compliances-dual-challenges-0-0', datePublished: 'November 30, 2020'}
  ];

  //inject services
  constructor() { }

  //retrieves the list of white papers
  getPapers() {
    return this.papers;
  }
}
